// extracted by mini-css-extract-plugin
export default {"ideas":"ideas_ideas__V2ouC","wrapper":"ideas_wrapper__DE7Tt","textInput":"ideas_textInput__aXY+j","input":"ideas_input__UzTka","label":"ideas_label__U8M1q","btn":"ideas_btn__t6MXn"};